import axiosInstance from "@/api/axios-instance";
import { PaymentPageFormData } from "@/pages/payment-pages/types/payment-page";

function parseJsonField(value?: string) {
  if (!value) return undefined;
  try {
    return JSON.parse(value);
  } catch {
    return undefined;
  }
}

export async function createPaymentPage(data: PaymentPageFormData) {
  const payload = {
    ...data,
    description: parseJsonField(data.description),
    plan_details: parseJsonField(data.plan_details),
    tnc: parseJsonField(data.tnc),
    how_it_works: parseJsonField(data.how_it_works),
    // Only a fully-targeted add-on is worth persisting.
    add_on: data.add_on?.target_standard_id ? data.add_on : undefined,
  };

  const response = await axiosInstance.post("/payment-pages", payload);
  return response.data;
}
